import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { ITask, ITaskState } from './types/Task-interface'

const taskCaseState = (state: RootState): ITaskState => state.taskCase

export const TaskCase = createSelector(
    [taskCaseState],
    (state): ITask => state.Task,
)
export const LoadingTask = createSelector(
    [taskCaseState],
    (state): boolean => state.isLoadingTask,
)
export const ErrorTask = createSelector(
    [taskCaseState],
    (state): string[] => state.errorTask,
)

export const LastFetchTask = createSelector(
    [taskCaseState],
    (state): null | number => state.lastFetchTime,
)
export const TaskID = createSelector(
    [taskCaseState],
    (state): string => state.TaskID,
)


export const Download = createSelector(
    [taskCaseState],
    (state): boolean => state.isDownload,
)
export const ErrorDownload = createSelector(
    [taskCaseState],
    (state): string[]  => state.errorDownload,
)
export const FileData = createSelector(
    [taskCaseState],
    (state): string => state.FileData,
)
export const FileName = createSelector(
    [taskCaseState],
    (state): string => state.FileName,
)